import React from 'react';
import { graphql } from 'gatsby';

import SectionItemContactFormHeadline from '../../../../components/Section/SectionItems/SectionItemContactFormHeadline';
import { normalizeContentPositionY, normalizeTextAlign } from '../../utils';

// Types
import { SectionItemContactFormHeadlineContainerFragment } from './__generated__/SectionItemContactFormHeadlineContainerFragment';

export const fragment = graphql`
  fragment SectionItemContactFormHeadlineContainerFragment on CMS_Section {
    contentPositionY
    headline
    headlineColor
    textAlign
  }
`;

type Props = {
  contentPositionY?: string;
  hasBackgroundImage: boolean;
  section: SectionItemContactFormHeadlineContainerFragment;
  textAlign?: string;
};

const SectionItemContactFormHeadlineContainer = ({ contentPositionY, hasBackgroundImage, section, textAlign }: Props) => {
  const headline = section.headline;

  if (typeof headline !== 'string') {
    return null;
  }

  const headlineColor = section.headlineColor;

  return (
    <SectionItemContactFormHeadline
      contentPositionY={contentPositionY || normalizeContentPositionY(section.contentPositionY)}
      hasBackgroundImage={hasBackgroundImage}
      text={headline}
      textAlign={textAlign || normalizeTextAlign(section.textAlign)}
      textColor={headlineColor}
    />
  );
};

export default SectionItemContactFormHeadlineContainer;
